<nav class="navbar navbar-icon-top navbar-expand-lg navbar-dark bg-white">
    <div class="d-inline-flex  headerLogoMarginCss ">
        <app-module-switcher class="ms-2"></app-module-switcher>
        <img class="headerLogo me-2 cursorPointer" src="{{headerLogo}}" routerLink="{{headerUrl}}" alt="Logo">
        <!-- <img  class="headerLogo me-2 cursorPointer " src="./assets/icons/header-logo.svg" routerLink="{{headerUrl}}" alt="Logo"> -->
    </div>
    <button id="navbar-toggler" class="navbar-toggler" type="button" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <em class="fas fa-bars"></em>
    </button>
    <div class="collapse navbar-collapse  bg-basic padding" style="padding-top:1px;padding-bottom:1px"
        id="navbarSupportedContent">
        <p class="headerTitle my-auto mr-auto text-center text-md-left">{{clientName | uppercase}} {{headerName |
            uppercase}}</p>
       <!--  <div [ngClass]="moduleUrl == 'pipeline-management' ? 'd-none' : 'd-block' " class="ms-3 w-12 form-control">
            <select class="w-100 border-none-outline-none" [(ngModel)]="selected_region" (change)="refreshPage()">
                <option *ngFor="let region of listOfregions" [value]="region.name">{{region.name}}</option>
            </select>
        </div> -->
        <div [ngClass]="moduleUrl == 'pipeline-management' ? 'd-none' : 'd-block' " class="ms-3 w-12 custom-form-control" style="background-color: #ffffff;">
            <ng-select class="custom-ng-select" [items]="listOfregions" bindLabel="name" [clearable]="false" [(ngModel)]="selected_region" (change)="refreshPage()">
            </ng-select>
        </div>
        <ul class="navbar-nav">
            <li *ngFor="let menu of menuItems" class="nav-item  px-1" (click)="onMenuClick('', menu.name,menu.routePath)">
                <a title="{{menu.name}}" class="nav-link hoverMenu"
                    [ngClass]="{'activeMenu': currentPage === menu?.name}" routerLink="{{menu.routePath}}">
                    <!-- <div class="pb-1" [ngClass]="menu.acronym == 'Help'? 'd-none':'d-block'"> -->
                    <div class="mb-1 m-auto" style="width: 18px; height:18px">
                        <img [ngClass]="currentPage === menu.name ? 'imageColor': ''"
                            *ngIf="menu?.class.includes('assets/')" [src]="menu?.class" width="100%" height="100%">
                        <em *ngIf="!menu.class.includes('assets/')" class="{{menu.class}} fs-18px"
                            [ngClass]="{'opacity-75': currentPage != menu?.name}"></em>
                    </div>
                    <!-- <div class="pb-1" [ngClass]="menu.acronym == 'Help'? 'd-block':'d-none'">
                        <em class="{{menu.class}}"></em></div> -->
                    {{menu.acronym | uppercase}}
                </a>
            </li>
            <!-- <li class="nav-item logout">
                <a title="Settings" class="nav-link dropdown-toggle hoverMenu" id="navbarDropdown1" role="button"
                    data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <em class="fa fa-cog"></em>
                    Settings
                </a>
                <div class="dropdown-menu" aria-labelledby="navbarDropdown1">
                    <a *ngIf="show2FA" class="dropdown-item cursorPointer" (click)="onMenuClick('2fa', '')">
                        <em class="fas fa-shield-alt pe-2"></em>
                        Change 2FA Mode
                    </a>
                    <a class="dropdown-item" routerLink="/auth/change-password"
                        (click)="onMenuClick('', 'Change Password')">
                        <em class="fa fa-key pe-2"></em>
                        Change Password
                    </a>
                    <a class="dropdown-item" routerLink="/auth/notification">
                        <em class="fas fa-cog pe-2"></em>
                        Notification Settings
                    </a>
                    <a *ngIf="userGroup.indexOf('Admin') > -1" class="dropdown-item cursorPointer"
                    (click)="commonService.navigateToAdmin()">
                    <em class="fas fa-user-shield pe-2"></em>
                    Open Admin Portal
                  </a>
                    <a class="dropdown-item cursorPointer" (click)="logout()">
                        <em class="fa fa-sign-out-alt pe-2"></em>
                        Logout
                    </a>
                </div>
            </li> -->
            <li class="nav-item dropdown">
                <div (click)="toggle()" title="{{userName}}" class="nav-link hoverMenu">
                    <em class="userIcon cursorPointer">{{shortName}}</em>
                </div>
                <div *ngIf="show == true" class="dropdown-menu1 box-shadow ms-5 mt-3 rounded-2"
                    style="background-color: white;">
                    <!-- <a *ngIf="show2FA" class="dropdown-item cursorPointer" (click)="onMenuClick('2fa', '')">
                    <em class="fas fa-shield-alt pe-2"></em>
                    Change 2FA Mode
                  </a> -->
                    <!-- <a class="dropdown-item" routerLink="/auth/change-password">
                    <em class="fa fa-key pe-2"></em>
                    Change Password
                  </a> -->
                    <!-- <a *ngIf="notificationSettings" class="dropdown-item" routerLink="/auth/notification">
                    <em class="fas fa-cog pe-2"></em>
                    Notification Settings
                  </a> -->
                    <!-- <a *ngIf="userGroup.indexOf('Admin') > -1" class="dropdown-item cursorPointer"
                    (click)="commonService.navigateToAdmin()">
                    <em class="fas fa-user-shield pe-2"></em>
                    Open Admin Portal
                  </a> -->
                    <a class="dropdown-item cursorPointer dropdown-style" (click)="logout()">
                        <em class="fa fa-sign-out-alt pe-2 pb-2 pt-2"></em>
                        Logout
                    </a>
                </div>
            </li>
        </ul>
    </div>
</nav>